/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * Defines the FeatureObject in the model objects. It is a helper object for creating reflective APIs such as toJSON()/fromJSON()/clone() etc.  
 */
export default class FeatureObject extends BaseMoserObject{

	type = null;

	featureID = 0;

	isList = false;

	isEnum = false;

	isModelledObjList = false;

	featureName = null;



	/**
	 * Set the value of the Class type for the feature
	 * @param {Class} type the Class type for this feature
	 */
	setType(type) {
		this.type = type;
	}

	/**
	 * Get the class type of a specific feature.
	 * @return {Class} Returns the Class type
	 */
	getType() {
		return this.type;
	}

	/**
	 * Set the feature ID for this feature
	 * @param {int} featureId the feature ID for this feature
	 */
	setFeatureID(featureId) {
		this.featureID = featureId;
	}

	/**
	 * Get the class type of a specific feature.
	 * @return {int} Returns the Class type
	 */
	getFeatureID() {
		return this.featureID;
	}

	/**
	 * Set if the feature is a list
	 * @param {boolean} isList is this feature a list
	 */
	setIsList(isList) {
		this.isList = isList;
	}

	/**
	 * Retrieve true if the feature is a list.
	 * @return {boolean} Returns true if the feature is a list, otherwise false
	 */
	getIsList() {
		return this.isList;
	}

	/**
	 * Set if the feature is an Enum
	 * @param {boolean} isEnum is this feature an Enum
	 */
	setIsEnum(isEnum) {
		this.isEnum = isEnum;
	}

	/**
	 * Retrieve true if the feature is an Enum.
	 * @return {boolean} Returns true if the feature is an Enum, otherwise false
	 */
	getIsEnum() {
		return this.isEnum;
	}

	/**
	 * Set the type of this feature
	 * @param {boolean} isModelledObjList is the type of this feature a List of MoserObject
	 */
	setIsModelledObjList(isModelledObjList) {
		this.isModelledObjList = isModelledObjList;
	}

	/**
	 * Retrieve true if the feature is an Enum.
	 * @return {boolean} Returns true if the feature is an Enum, otherwise false
	 */
	getIsModelledObjList() {
		return this.isModelledObjList;
	}

	/**
	 * Set the name of this feature
	 * @param {String} featureName the name of this feature
	 */
	setFeatureName(featureName) {
		this.featureName = featureName;
	}

	/**
	 * Get the name of this feature
	 * @return {String} The feature name
	 */
	getFeatureName() {
		return this.featureName;
	}
}


// WEBPACK FOOTER //
// ./src/generated/FeatureObject.js